import { Typography, Box } from '@mui/material';

export function DreFormTitle({ label }: { label: string }) {
    return (
        <Box
            sx={{
                px: 2,
                py: 0.5,
                height: 40,
                display: 'flex',
                backgroundColor: 'primary.main',
                borderRadius: 1,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
            }}
        >
            <Typography variant="subtitle1" sx={{ color: 'common.white' }}>
                {label}
            </Typography>
        </Box>
    );
}
